import React, { useState, useEffect } from "react";
import axios from "axios";
import Reject from "../../../assets/Icon/Rejected.png";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import PostAllDataModule from "../../../Components/Reuseable/PostAllDataModule";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const RejectPost = () => {
  const [event_data, setEvents] = useState([]);
  const [totalRejected, setTotalRejected] = useState("");

  const [buffer, setBuffer] = useState(true);

  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/admin/simple_post/rejected`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.post);
        setTotalRejected(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Rejected Post"
        image={Reject}
        count={totalRejected}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <PostAllDataModule
          data={event_data}
          urlLink={`/superstar-admin/post/details`}
        />
      )}
    </>
  );
};

export default RejectPost;
